import { create } from "zustand";
import { mirroredStore } from "@/lib/mirrored-store";

export const VOICE_COMMAND_FEEDBACK_MS = 2200;

type VoiceCommandFeedback = {
  label: string | null;
  announcedAt: number;
};

export const useVoiceCommandFeedback = create<VoiceCommandFeedback>()(
  mirroredStore<VoiceCommandFeedback>("voiceCommandFeedback", () => ({
    label: null,
    announcedAt: 0,
  })),
);

export function announceVoiceChatCommand(label: string): void {
  useVoiceCommandFeedback.setState((state) => ({
    label,
    announcedAt: Math.max(Date.now(), state.announcedAt + 1),
  }));
}
